import { 
  Component, 
  OnInit, 
  OnDestroy, 
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';

import { Store } from '@ngxs/store';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EngineService } from 'src/app/engine/engine.service';

import { EventsEnum } from 'src/app/engine/models/events.enum';
import { LoadProgressModel } from 'src/app/engine/models/load-progress.model';
import { Breakpoint } from 'src/app/breakpoint/models/breakpoint.enum';

import { BreakpointState } from 'src/app/breakpoint/state/breakpoint.state';

@Component({
  selector: 'app-view-layers-bar',
  templateUrl: './view-layers-bar.component.html',
  styleUrls: ['./view-layers-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewLayersBarComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();

  assetsLoading = false;

  constructor(
    private store: Store,
    private engineService: EngineService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.engineService
    .getEvent(EventsEnum.AssetsLoadProgress)
    .pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((progress: LoadProgressModel) => {
      this.assetsLoading = progress.requestedAssets !== progress.receivedAssets;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isLarge(): boolean {
    const breakpoint = this.store.selectSnapshot(BreakpointState.getBreakpoint);
    return breakpoint >= Breakpoint.Medium;
  }

}
